import React, { useMemo } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { getCategory, CATEGORIES } from "@/lib/categories";
import { ArrowUpRight, Check } from "lucide-react";

const CategoryPage = () => {
  const { slug } = useParams();
  const cat = getCategory(slug);
  const otherCategories = useMemo(
    () => (cat ? CATEGORIES.filter((c) => c.slug !== cat.slug) : []),
    [cat]
  );
  if (!cat) return <Navigate to="/" replace />;
  const Icon = cat.icon;

  return (
    <main className="bg-white">
      <section className="pt-32 lg:pt-40 pb-20 bg-razmek-alt">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3">
              <Icon size={20} className="text-razmek-gold" strokeWidth={1.4} />
              <span className="eyebrow text-razmek-gold">Protección · {cat.label}</span>
            </div>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-6 leading-[1.02] text-razmek-dark">
              {cat.label}
              <span className="text-razmek-gold">.</span>
            </h1>
            <p className="mt-8 font-sans text-lg lg:text-xl leading-relaxed text-razmek-dark/70 max-w-xl">
              {cat.problem}
            </p>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <Link
              to="/precalificacion"
              className="group inline-flex items-center gap-3 bg-razmek-blue hover:bg-razmek-dark text-white px-7 py-5 font-sans tracking-[0.16em] uppercase text-[11px] border-2 border-razmek-blue hover:border-razmek-gold transition-all"
            >
              Agendar asesoría
              <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="eyebrow">Nuestro enfoque</div>
            <h2 className="font-serif text-3xl lg:text-4xl mt-4 text-razmek-dark leading-tight">
              Una solución <span className="italic text-razmek-blue">diseñada</span>, no enlatada.
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p className="font-sans text-base lg:text-lg leading-relaxed text-razmek-dark/75">
              {cat.benefit}
            </p>
            <ul className="mt-10 space-y-5">
              {cat.bullets.map((b) => (
                <li key={b} className="flex items-start gap-4 border-b border-razmek pb-5">
                  <Check size={18} className="text-razmek-gold mt-1 shrink-0" strokeWidth={1.6} />
                  <span className="font-serif text-xl text-razmek-dark">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-razmek-blue text-white py-24 lg:py-28">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10 text-center">
          <div className="eyebrow text-razmek-gold">Siguiente paso</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-6 leading-[1.05]">
            Hablemos de tu cobertura
            <br />
            de <span className="italic">{cat.label.toLowerCase()}</span>.
          </h2>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6">
            <Link
              to="/precalificacion"
              className="bg-razmek-gold hover:bg-white hover:text-razmek-dark text-white px-7 py-4 font-sans tracking-[0.16em] uppercase text-[11px] border-2 border-razmek-gold transition-all"
            >
              Comenzar precalificación
            </Link>
            <a
              href={`https://wa.me/5215583570588?text=Hola%20RAZMEK%2C%20me%20interesa%20${cat.label}`}
              target="_blank"
              rel="noreferrer"
              className="link-underline font-sans tracking-[0.16em] uppercase text-[11px] text-white"
            >
              WhatsApp directo
            </a>
          </div>
        </div>
      </section>

      <section className="py-20 bg-razmek-alt">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
          <div className="eyebrow text-razmek-gray">Otras áreas</div>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-razmek-blue/10">
            {otherCategories.map((c) => {
              const I = c.icon;
              return (
                <Link
                  key={c.slug}
                  to={`/proteger/${c.slug}`}
                  className="bg-white p-6 flex flex-col items-start gap-4 hover:bg-razmek-dark hover:text-white transition-colors group"
                >
                  <I size={20} strokeWidth={1.3} className="text-razmek-blue group-hover:text-razmek-gold" />
                  <span className="font-serif text-xl">{c.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
};

export default CategoryPage;
